<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/l5mO3T/tc-custom/9781625670564.jpg?1692135101397" alt="This image is the cover for the book Mark Dalton: Owner/Operator"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Mark Dalton: Owner/Operator
      </h1>
      <p class="bookDescription body article font2">
        <p>LOOKING FOR TROUBLE: Mark Dalton isn’t sure if he finds trouble or if trouble finds him. But ever since his wife traded him in for a prettier model, and he traded in his Private Eye business for a Peterbilt, it seems to be everywhere he goes. In this collection of loosely interwoven who-dunnits, Edo van Belkom introduces Mark Dalton, Trucker Detective. Whether he’s scooping up pretty hitchhikers with secrets, getting back goods stolen right out from under his nose, making a shady repair shop pay, or solving a racially charged, post-9/11 murder, Dalton is one busy trucker. And truth is, he wouldn’t have it any other way.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Edo van Belkom
      </h2>
      
      <p class="authorDescription body article">Bram Stoker and Aurora Award winner Edo van Belkom is the author of two hundred stories of horror, science fiction, fantasy, and mystery, which have appeared in such magazines and anthologies as <i>Storyteller, RPM for Truckers, Year’s Best Horror Stories</i>, and <i>The Mammoth Book of On the Road</i>. He is also the author of “Mark Dalton: Owner/Operator,” an ongoing adventure serial about a private investigator turned trucker that has been published continuously in the monthly trade magazine <i>Truck News</i> since June of 1999. His more than twenty books to date include the novels <i>Scream Queen, Martyrs</i>, and <i>Teeth</i> and the short story collections <i>Death Drives a Semi</i> and <i>Six-Inch Spikes</i>. Born in Toronto in 1962, Edo worked as a daily newspaper sports and police reporter for five years before becoming a full-time freelance writer in 1992. He lives in Brampton, Ontario, with his wife, Roberta, and son, Luke. His Web page is located at www.vanbelkom.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Jabberwocky Literary Agency, Inc.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d38f369c